import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl, Button } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { useEffect, useState } from '@wordpress/element'
import apiFetch from '@wordpress/api-fetch';

/**
 * Adding StripeIdeal Content
 */
addFilter( 'wp_travel_payment_gateway_fields_stripe_ideal', 'wp-travel', (content) => {
    return [ ...content, <StripeIdealContent /> ]
});

const StripeIdealContent = () => {

    const [isSendingTest, setIsSendingTest] = useState(false);

    const [isDisabled, setIsDisabled] = useState(false);

    const [apiData, setApiData] = useState([]);

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_stripe_ideal,
        stripe_ideal_publishable_key,
        stripe_ideal_secret_key,
        stripe_ideal_test_publishable_key,
        stripe_ideal_test_secret_key,
        wt_test_mode
    } = allData

    const getApiResponse = () => {
        setIsSendingTest(true);
        setIsDisabled(true);
        apiFetch({
            url: `${ajaxurl}?action=wp_travel_stripe_ideal_get_webhook_url`,
            method: 'post',
        }).then( res => {
            setApiData(res);
            setIsSendingTest(false);
        });
    }

    const afterGeneratingData = () => {
        if (apiData && false == apiData.success) {
            if ( 'undefined' !== typeof apiData.data.secret_key_na ){
                return <p className="description notice-warning notice" style={{ color: 'red' }} dangerouslySetInnerHTML={{ __html: apiData.data.secret_key_na }}></p>
            } else {
                return <p className="description notice-warning notice" style={{ color: 'red' }} dangerouslySetInnerHTML={{ __html: apiData.data.message }}></p>
            }
        } else if ( apiData && true == apiData.success ) {
            return <p className="howTo" style={{ color: 'green' }} dangerouslySetInnerHTML={{ __html: apiData.data.message }}></p>
        }
    }

    const webhookPlaceholder = () => {
        if ( apiData && false == apiData.success ) {
            if ( 'undefined' !== typeof apiData.data.secret_key_na ){
                return 'Webhook Missing'
            } else {
                return apiData.data.url
            }
        } else if ( apiData && true == apiData.success ) {
            return apiData.data.url
        }
    }

    /**
     * Fetch the API data on the component load.
     * Its like the componentDidMount but for functional components.
     */
    useEffect(() => {
        if ( 'yes' == wt_test_mode ) {
            if ( ('undefined' !== typeof stripe_ideal_test_publishable_key && '' !== stripe_ideal_test_publishable_key) || ('undefined' !== typeof stripe_ideal_test_secret_key && '' !== stripe_ideal_test_secret_key) ) {
                getApiResponse();
            }
        } else {
            if ( ('undefined' !== typeof stripe_ideal_publishable_key && '' !== stripe_ideal_publishable_key) || ('undefined' !== typeof stripe_ideal_secret_key && '' !== stripe_ideal_secret_key) ) {
                getApiResponse();
            }
        }
    },[]);

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-stripe-ideal' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-stripe-ideal' ) }</p></strong>
            }

            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_stripe_ideal }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_stripe_ideal == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_stripe_ideal: 'yes' == payment_option_stripe_ideal ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{_wp_travel.setting_strings.payment.enable_stripe_ideal_note}</p>
                </div>
            </PanelRow>

            {
                payment_option_stripe_ideal === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.stripe_webhook }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    disabled
                                    placeholder={ webhookPlaceholder() }
                                />
                                {afterGeneratingData()}
                                <p className="description">{ _wp_travel.setting_strings.payment.stripe_webhook_note }</p>
                                <Button
                                    onClick={getApiResponse}
                                    isBusy={isSendingTest}
                                    disabled={isDisabled}
                                    isSecondary
                                >{ _wp_travel.setting_strings.payment.stripe_webhook_test_webhook }</Button>
                                <p className="description">{  _wp_travel.setting_strings.payment.stripe_webhook_test_webhook_note }</p>
                            </div>
                    </PanelRow>

                    {
                    wt_test_mode === 'yes' &&
                        <>
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.payment.stripe_ideal_test_publishable_key }</label>
                                <div className="wp-travel-field-value">
                                    <TextControl
                                        value={ 'undefined' !== typeof stripe_ideal_test_publishable_key ? stripe_ideal_test_publishable_key : '' }
                                        onChange={
                                            (value) => {
                                                updateSettings({
                                                    ...allData,
                                                    stripe_ideal_test_publishable_key: value
                                                })
                                                setIsDisabled(false)
                                            }
                                        }
                                    />
                                </div>
                        </PanelRow>

                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.payment.stripe_ideal_test_secret_key }</label>
                                <div className="wp-travel-field-value">
                                    <TextControl
                                        value={ 'undefined' !== typeof stripe_ideal_test_secret_key ? stripe_ideal_test_secret_key : '' }
                                        onChange={
                                            (value) => {
                                                updateSettings({
                                                    ...allData,
                                                    stripe_ideal_test_secret_key: value
                                                })
                                                setIsDisabled(false)
                                            }
                                        }
                                    />
                                </div>

                        </PanelRow>
                        </>
                    }
                    {
                    wt_test_mode === 'no' &&
                        <>
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.payment.stripe_ideal_live_publishable_key }</label>
                                <div className="wp-travel-field-value">
                                    <TextControl
                                        value={ 'undefined' !== typeof stripe_ideal_publishable_key ? stripe_ideal_publishable_key : '' }
                                        onChange={
                                            (value) => {
                                                updateSettings({
                                                    ...allData,
                                                    stripe_ideal_publishable_key: value
                                                })
                                                setIsDisabled(false)
                                            }
                                        }
                                    />
                                </div>
                        </PanelRow>

                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.payment.stripe_ideal_live_secret_key }</label>
                                <div className="wp-travel-field-value">
                                    <TextControl
                                        value={ 'undefined' !== typeof stripe_ideal_secret_key ? stripe_ideal_secret_key : '' }
                                        onChange={
                                            (value) => {
                                                updateSettings({
                                                    ...allData,
                                                    stripe_ideal_secret_key: value
                                                })
                                                setIsDisabled(false)
                                            }
                                        }
                                    />
                                </div>
                        </PanelRow>
                        </>
                    }
                </>
            }
        </>
    )
}
